// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n44B","col":"styles_col__16tP7"};